export const cobrandingPrefixText = ({cobranding_prefix, cobrandable}) => (
  `${cobranding_prefix ? cobranding_prefix : ''} ${cobrandable.name}`
)

export const hasEverplansCobranding = ({enabled, style}) => enabled && style === 'everplans_branded'

export const hasOrganizationCobranding = organizationCobranding => (
  organizationCobranding?.enabled &&
  organizationCobranding?.type === 'organization'
)

export const isCobrandableTypePartner = ({cobrandable_type}) => cobrandable_type === 'Partner'

export const validHexColor = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
